import { ReactNode, useEffect, useRef, useState } from "react";
import FreestarAdSlot from "./FreestarAdSlot";

const STICKY_TOP = "120px"; // mastheadHeight(60px) + page padding-top(60px)
const MIN_RAIL_WIDTH = 300;

function useProbeRect() {
  const [el, setEl] = useState<HTMLDivElement | null>(null);
  const [rect, setRect] = useState<DOMRect | null>(null);

  useEffect(() => {
    if (!el) return;
    const measure = () => setRect(el.getBoundingClientRect());
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(document.documentElement);
    measure();
    return () => resizeObserver.disconnect();
  }, [el]);

  const fits = rect !== null && rect.width >= MIN_RAIL_WIDTH;
  return { probe: setEl, fits, rect };
}

function probeCenterLeft(rect: DOMRect, adWidth: number) {
  return (rect.left + rect.right) / 2 - adWidth / 2;
}

export function FreestarLeftRail() {
  const { probe, fits, rect } = useProbeRect();
  const everFits = useRef(false);
  if (fits) everFits.current = true;

  return (
    <div ref={probe} className="rail-probe">
      {everFits.current && rect !== null && (
        <div
          style={{
            position: "fixed",
            top: STICKY_TOP,
            left: probeCenterLeft(rect, 300),
            width: 300,
            zIndex: 101,
            overflow: "hidden",
            display: fits ? "flex" : "none",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* <div style={{ width: 300, height: 600, background: "rgba(100,100,255,0.2)", border: "2px dashed #6464ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#6464ff", fontSize: 12 }}>
            300×600 Ad
          </div> */}
          <FreestarAdSlot placementName="probuildstats-com_left_rail" slotId="probuildstats-com_left_rail" adSize="__300x600" />
        </div>
      )}
    </div>
  );
}

export function FreestarRightRail() {
  const { probe, fits, rect } = useProbeRect();

  return (
    <div ref={probe} className="rail-probe">
      {rect !== null && (
        <div
          style={{
            position: "fixed",
            top: STICKY_TOP,
            left: probeCenterLeft(rect, 300),
            width: 300,
            zIndex: 101,
            overflow: "hidden",
            display: fits ? "flex" : "none",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* <div style={{ width: 300, height: 250, background: "rgba(100,100,255,0.2)", border: "2px dashed #6464ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#6464ff", fontSize: 12 }}>
            300×250 Ad
          </div> */}
          <FreestarAdSlot placementName="probuildstats-com_right_rail" slotId="probuildstats-com_right_rail" adSize="__300x250" />
        </div>
      )}
    </div>
  );
}

export function RailLayout({ children, rightRail = true }: { children: ReactNode; rightRail?: boolean }) {
  return (
    <div className="rail-layout">
      <FreestarLeftRail />
      {children}
      {rightRail ? <FreestarRightRail /> : <div />}
    </div>
  );
}
